module.exports = __webpack_public_path__ + "static/policy-delete-47f4895845b0c361194ece9a5c4f45af.png";